import React from 'react';

const PlaywrightAutomation = () => {
  return (
    <div>
      <h2>Playwright Automation</h2>
      <p>
        Welcome to the Playwright Automation section. Here you can explore how to automate browser flows using Playwright, a powerful and modern automation framework that supports multiple browsers and platforms!
      </p>
    </div>
  );
};

export default PlaywrightAutomation;